import { ApiConfig } from "./apiConfig";

export const get_auditlog_lists_with_pagination = async (data) => {
    try {
      const response = await ApiConfig.post(`getLogsList`, data, { headers: { "Content-Type": "multipart/form-data" } });
      return response;
    } catch (error) {
      throw error;
    }
  };